"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACILITY_SCOPED_SHARED_TABLES = exports.SHARED_TABLE_SCOPE_KEYS = exports.SHARED_TABLE_SCHEMAS = void 0;
const BusLoanLevel_1 = require("./BusLoanLevel");
const DataLake_1 = require("./DataLake");
/**
 * Registry of the shared (cross-deal) datalake tables: for each table, the row
 * type it holds and its Glue schema, both fixed in code.
 *
 * Why it exists: the writer used to take a table prefix and a schema as two
 * unrelated arguments, so nothing stopped a caller pairing one table's name
 * with another table's columns (and the Glue step would then add those columns
 * to the wrong table). Shared tables are expected to grow beyond BUS, so the
 * pairing is declared once here and the writer
 * (`Artifact.updateSharedDatalakeTable`) takes only the table name: it looks
 * the schema up, types the rows to the table, and writes both the versioned
 * and `_latest` tables.
 *
 * Adding a shared table:
 *  1. add its name to `DataLake.SHARED_TABLES`;
 *  2. add its row type to `SharedTableRows`, its schema to
 *     `SHARED_TABLE_SCHEMAS` and its scope keys to `SHARED_TABLE_SCOPE_KEYS`
 *     (each a compile error until you do);
 *  3. call `updateSharedDatalakeTable` with rows of that type and its scope.
 * Rows need no RLS stamping from the writer, but the table's readers do:
 * stamp the org slugs its Omni topics filter on (BUS: borrower_slug /
 * lender_slug) when building the rows.
 */
// Checks every table declares its scope keys (and only known keys) while
// keeping each table's keys as a literal tuple.
const scopeKeysFor = (keys) => keys;
exports.SHARED_TABLE_SCHEMAS = {
    bus_loan_level: BusLoanLevel_1.BUS_LOAN_LEVEL_GLUE_SCHEMA,
};
/**
 * Each table's scope keys, in order: the partition keys that lead its
 * partitions, before the period keys every versioned / `_latest` pair ends
 * with (`reportingdate`, plus `fileversion` on the versioned table). The
 * Glue table's keys and every write's values are both built from this list, so
 * they can't disagree (Glue matches values to keys by position).
 *
 * Why scope keys: a `_latest` write replaces its partition by deleting
 * everything under the partition's S3 prefix, so the scope must name exactly
 * one writer's data. BUS scopes by facility, first, so each deal's data is one
 * S3 prefix (a rebuild or teardown is a prefix delete that can't touch another
 * deal). A table scoped differently (an org, or nothing for a single-writer
 * table) declares its own keys here.
 */
exports.SHARED_TABLE_SCOPE_KEYS = scopeKeysFor({
    bus_loan_level: ['credit_facility_id'],
});
const isFacilityScopedSharedTable = (table) => {
    const keys = exports.SHARED_TABLE_SCOPE_KEYS[table];
    return keys.length === 1 && keys[0] === 'credit_facility_id';
};
exports.FACILITY_SCOPED_SHARED_TABLES = DataLake_1.SHARED_TABLES.filter(isFacilityScopedSharedTable);
//# sourceMappingURL=SharedDatalakeTables.js.map